export default function MinusIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="2" viewBox="0 0 8 2" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
      <line x1="0" y1="1" x2="8" y2="1" />
    </svg>
  )
}
